import { authReportQt, lookUpReportQt } from '../utils/qt-report'

export const getApiPermission = api => {
  const menus = Object.values(api).map(v => v.toLowerCase())
  // 不区分大小写
  menus.includes = function includes (val) {
    if (val) {
      if (val.indexOf('BT') === 0) {
        return [].indexOf.call(this, val) >= 0
      }
      setTimeout(authReportQt(val), 0)
      return [].includes.call(this, val.toLowerCase().replace(/\$/g, ''))
    } else {
      return false
    }
  }
  // 复写 indexOf 方法
  menus.indexOf = function indexOf (val) {
    if (val) {
      if (val.indexOf('BT') === 0) {
        return [].indexOf.call(this, val)
      }
      setTimeout(authReportQt(val), 0)
      return [].indexOf.call(this, val.toLowerCase().replace(/\$/g, ''))
    } else {
      return -1
    }
  }
  return menus
}

// 代理 store 中数据字典数据的记录情况并上报qt
export const getProxyLookUpInStore = (data) => {
  const lookUpData = new Proxy(data, {
    get(target, prop) {
      const data = target[prop]
      if (data) {
        setTimeout(lookUpReportQt(prop), 0)
      }
      return data
    }
  })
  return lookUpData
}

// 覆写 window 下数据字典数据 的数组查找方法并上报 qt使用情况
export const getProxyLookUpInWindow = (lookUpData) => {
  lookUpData.find = function find (callback) {
    const findData = [].find.call(this, callback)
    if (findData) {
      setTimeout(lookUpReportQt(findData.code), 0)
    }
    return findData
  }

  lookUpData.filter = function filter (callback) {
    const filterData = [].filter.call(this, callback)
    if (filterData) {
      setTimeout(lookUpReportQt(filterData[0].code), 0)
    }
    return filterData
  }

  return lookUpData
}

// 获取属于ERP系统的菜单的子系统编码，菜单管理模块有移动端APP建立的菜单（需要过滤掉）
export const getSubsystemCodes = arr => {
  if (arr) {
    let item = arr.find(v => v.code === 'auth_menu_resource_sub_system_title')
    if (item && item.value) {
      return item.value.reduce((s, v) => {
        let code = v.lookupCode
        let arr = v.lookupValue.split('/')
        let title = arr[1].replace('.', '•')
        let obj = s.codes.find(k => k.title === title)
        if (obj) {
          obj.subSystem = `${obj.subSystem},${code}`
        } else {
          s.codes.push({
            icon: arr[0],
            label: title,
            title,
            tips: arr[2],
            subSystem: code,
            children: []
          })
        }
        s[code] = title
        return s
      }, { codes: [] })
    }
  }
  return {}
}

export const handleMenus = (menus, rootMenus, codes, homeMenus) => {
  let indexMenu = menus['/'] || {}
  Object.values(rootMenus).forEach(v => {
    let sys = v.subSystem
    let obj = codes.find(k => {
      let ksys = k.subSystem
      return (ksys.includes(',') && ksys.split(',').includes(sys)) || (ksys === sys)
    })
    if (obj && v.id !== indexMenu.id && !homeMenus.includes(v.menuCode)) {
      obj.children.push(v)
    } else if (v.id === indexMenu.id) {
      indexMenu = v
    }
  })
  if (indexMenu.id) {
    codes.splice(0, 0, indexMenu)
  }
  const tree = menus.menuTree
  codes.filter(v => (v.children && v.children.length > 0) || !!v.id).forEach((v, i) => {
    tree[i] = v
  })
}



// WEBPACK FOOTER //
// ./src/public/store/utils.js